import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-container px-container my-16 md:my-16" }
const _hoisted_2 = { class: "flex flex-col md:flex-row md:space-x-8 lg:space-x-16" }
const _hoisted_3 = { class: "w-full md:w-1/3" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "p-8 text-center" }, [
  /*#__PURE__*/_createVNode("h3", { class: "text-2xl font-bold" }, "Camiseta Oficial de AMFF"),
  /*#__PURE__*/_createVNode("p", { class: "font-bold text-amff-teal" }, "5 puntos")
], -1)
const _hoisted_5 = { class: "w-full md:w-1/3" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "p-8 text-center" }, [
  /*#__PURE__*/_createVNode("h3", { class: "text-2xl font-bold" }, "Tote bag official de AMFF"),
  /*#__PURE__*/_createVNode("p", { class: "font-bold text-amff-teal" }, "3 puntos")
], -1)
const _hoisted_7 = { class: "w-full md:w-1/3" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "p-8 text-center" }, [
  /*#__PURE__*/_createVNode("h3", { class: "text-2xl font-bold" }, "3 meses de Filmin"),
  /*#__PURE__*/_createVNode("p", { class: "font-bold text-amff-teal" }, "4 puntos")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BonoBannerStripe = _resolveComponent("BonoBannerStripe")
  const _component_ImageCard = _resolveComponent("ImageCard")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_BonoBannerStripe, {
      class: "text-4xl sm:text-5xl lg:text-6xl text-center md:mb-10",
      text: "Regalos."
    }),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_ImageCard, {
          class: "mb-6 mt-6 md:mb-0",
          src: `${_ctx.baseURL}img/bono/camiseta-bg.png?date=2022-07-06`,
          srcset: 
            [
              `${_ctx.baseURL}img/bono/camiseta-bg.png?date=2022-07-06 1x`,
              `${_ctx.baseURL}img/bono/camiseta-bg@2x.png?date=2022-07-06 2x`,
              `${_ctx.baseURL}img/bono/camiseta-bg@3x.png?date=2022-07-06 3x`,
            ].join(', ')
          
        }, {
          content: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["src", "srcset"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_ImageCard, {
          class: "mb-6 mt-6 md:mb-0",
          src: `${_ctx.baseURL}img/bono/tote-bag-bg.png?date=2022-07-06`,
          srcset: 
            [
              `${_ctx.baseURL}img/bono/tote-bag-bg.png?date=2022-07-06 1x`,
              `${_ctx.baseURL}img/bono/tote-bag-bg@2x.png?date=2022-07-06 2x`,
              `${_ctx.baseURL}img/bono/tote-bag-bg@3x.png?date=2022-07-06 3x`,
            ].join(', ')
          
        }, {
          content: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["src", "srcset"])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_ImageCard, {
          class: "mb-6 mt-6 md:mb-0",
          src: `${_ctx.baseURL}img/bono/tarjeta-filmin-bg.png?date=2022-07-06`,
          srcset: 
            [
              `${_ctx.baseURL}img/bono/tarjeta-filmin-bg.png?date=2022-07-06 1x`,
              `${_ctx.baseURL}img/bono/tarjeta-filmin-bg@2x.png?date=2022-07-06 2x`,
              `${_ctx.baseURL}img/bono/tarjeta-filmin-bg@3x.png?date=2022-07-06 3x`,
            ].join(', ')
          
        }, {
          content: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["src", "srcset"])
      ])
    ])
  ]))
}